export const defaultFormConfig = {
    value: '',
    valid: false,
    touched: false
};
